import { api } from "@/lib/api";
import { deviceId } from "@/lib/feed";

export const POST_TYPES = [
  { key: "video", label: "Video", hint: "Clips, product stories, music videos" },
  { key: "audio", label: "Music", hint: "Tracks with cover art" },
  { key: "art", label: "Exhibition", hint: "Artwork & photo pieces" },
  { key: "show", label: "Live show", hint: "Performances, matches, launches" },
  { key: "game", label: "Game", hint: "Quiz or prediction the audience plays" },
];

export const typeLabel = (t) => POST_TYPES.find((p) => p.key === t)?.label || t;

export const getStore = (sellerId) => api.get(`/stage/store/${sellerId}`).then((r) => r.data);
export const getPost = (id) => api.get(`/stage/posts/${id}`).then((r) => r.data);
export const getHighlights = (limit = 6) => api.get(`/stage/highlights?limit=${limit}`).then((r) => r.data.posts);
export const toggleFollow = (sellerId) => api.post(`/stage/follow/${sellerId}`).then((r) => r.data);
export const toggleReact = (id) => api.post(`/stage/posts/${id}/react`).then((r) => r.data);
export const trackStageView = (id) => api.post(`/stage/posts/${id}/view`, null, { headers: { "X-Device-Id": deviceId() } }).catch(() => {});
export const listComments = (id) => api.get(`/stage/posts/${id}/comments`).then((r) => r.data);
export const addComment = (id, text) => api.post(`/stage/posts/${id}/comments`, { text }).then((r) => r.data);
export const playGame = (id, option_index) => api.post(`/stage/posts/${id}/play`, { option_index }).then((r) => r.data);
export const gameResults = (id) => api.get(`/stage/posts/${id}/results`).then((r) => r.data);
export const myStage = () => api.get("/stage/mine").then((r) => r.data);
export const createPost = (body) => api.post("/stage/posts", body).then((r) => r.data);
export const updatePost = (id, body) => api.patch(`/stage/posts/${id}`, body).then((r) => r.data);
export const deletePost = (id) => api.delete(`/stage/posts/${id}`).then((r) => r.data);
export const setLive = (id, state) => api.post(`/stage/posts/${id}/live`, { state }).then((r) => r.data);
export const updateStore = (body) => api.patch("/stage/store", body).then((r) => r.data);

export const stageShareUrl = (postId) => `${process.env.REACT_APP_BACKEND_URL}/api/share/stage/${postId}`;

/** Chunked media upload → returns { media_file_id, size, content_type }. onProgress(0..1). */
export async function uploadStageMedia(file, onProgress) {
  const { data: start } = await api.post("/stage/upload/start", { filename: file.name, content_type: file.type, size: file.size });
  const chunk = start.chunk_size;
  const total = Math.ceil(file.size / chunk);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk, Math.min(file.size, (i + 1) * chunk));
    await api.put(`/stage/upload/${start.upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.((i + 1) / total);
  }
  const { data } = await api.post(`/stage/upload/${start.upload_id}/finish`);
  return data;
}
